module.exports = __webpack_public_path__ + "img/logo.923e776e.png";